const apiUrl = process.env.VUE_APP_API_BASEURL;

export default {
  check: `${apiUrl}/healthz`,
};
